import React from 'react'
import PropTypes from 'prop-types'
import styles from './DataFilters.module.scss'

const DataFilters = ({ children, className = undefined }) => {
  const classNames = [styles.dataFilters, className].filter(Boolean).join(' ')

  return (
    <div className={classNames}>
      {children}
    </div>
  )
}

DataFilters.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default DataFilters
